var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex back-button-span"},[_c('a',{on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":'/assets/images/icon_back.svg'}}),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.$t('general.back'))+" "+_vm._s(_vm.title))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }